import React, { Component, createRef } from 'react';
import Validator from 'validatorjs';
import * as QueryString from 'query-string';
import ReCAPTCHA from 'react-google-recaptcha';
import { Redirect, Link } from 'react-router-dom';
import { Form, Row, Col, Image } from 'react-bootstrap';

import './Auth.css';

import { Http } from '../../support';
import { Auth } from '../../support';
import Storage from '../../support/Storage';
import { FormControl } from '../../facturotopia';
import LoadingButton from '../../facturotopia/LoadingButton';
import ResponseError from '../../shared/responses/ResponseError';
import ResponseResult from '../../shared/responses/ResponseResult';

class ReceptoresPasswordEmail extends Component {

  state = {};

  recaptchaRef = null;

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      busy: false,
      restored: false,
      isLoggedIn: false,
      validator: new Validator({}, this.getRules({}))
    };

    this.recaptchaRef = createRef();
  }

  async componentDidMount() {
    let isLoggedIn = Auth.isAuthenticated();

    if (!Auth.isAuthenticated() && !!Auth.getUser()) {
      const data = await Storage.get('facturotopia');

      if (!!data) {
        Auth.setData(data);

        isLoggedIn = true;
      }
    } else {
      await Auth.logout();
    }

    if (isLoggedIn) {
      this.setState({
        isLoggedIn
      });
    } else {
      setTimeout(() => {
        this.setState({
          loaded: true
        });
      });
    }
  }

  getRules(data) {
    if (!!data.username && data.username.indexOf('@') === -1) {
      return {
        rfc: ['required', 'string', 'max:13', 'regex:/^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9][A-Z,0-9][0-9,A-Z]$/'],
        username: ['required', 'string'],
      }
    }

    return {
      rfc: ['required', 'string', 'max:13', 'regex:/^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9][A-Z,0-9][0-9,A-Z]$/'],
      username: ['required', 'email'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.getRules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnSubmit = async () => {
    this.setState({
      busy: true,
      error: null
    });

    try {
      const token = await this.recaptchaRef.current.executeAsync();

      const params = {
        ...this.state.data,
        challenge: token
      }

      const query = QueryString.parse(this.props.location.search);

      const headers = {
        'X-Tenancy': query.tenancy
      }

      const response = await Http.post('/receptores/auth/password/email', params, { headers });

      this.setState({
        result: response,
        busy: false
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false
      });
    }
  }

  handleOnAction = () => {
    const query = QueryString.parse(this.props.location.search);

    const pathname = !!query.tenancy ? `/ext/receptores/auth/login?tenancy=${query.tenancy}` : '/ext/receptores/auth/login';

    this.props.history.replace(pathname);
  }

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Solicitud recibida"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          variant="inline"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  onCaptchaChange = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        challenge: value
      }
    });
  }

  render() {
    const {
      data,
      isValid,
      isLoggedIn,
      busy,
      loaded,
      error,
      result
    } = this.state;

    const rules = this.getRules(data);

    const query = QueryString.parse(this.props.location.search);

    if (isLoggedIn) {
      let { from } = this.props.location.state || { from: { pathname: '/ext/receptores/facturas' } };

      if (from.pathname === '/ext/receptores/auth/login') {
        from.pathname = '/ext/receptores/facturas';
      }

      return <Redirect to="/bridge/receptores" state={ from } />;
    }

    if (!loaded) {
      return <Row></Row>
    }

    if (result) {
      return this.renderResult();
    }

    return (
      <Form autoComplete="off">

        <div className="auth-content">
          <div className="avatar mt-4">
            <Row className="auth-logo">
              <Col className="d-flex justify-content-start logo-container">
                  <Image src="/img/logo.png"
                    className="auth-logo-img"
                    fluid={ true }
                  />
                  <span>Facturotöpía</span>
              </Col>
            </Row>
          </div>

          <div className="login-content">
            <div className="pb-3">
              <h6 className="text-muted">
                Solicita tu invitación
              </h6>
            </div>

            <div className="form-box">
              <p className="text-muted">
                Ingresa la información que se solicita, te enviaremos las instrucciones a tu correo electrónico para completar la invitación y obtener acceso a la plataforma.
              </p>

              <FormControl type="username"
                label="RFC"
                name="rfc"
                casing={ 'upper' }
                autoFocus={ true }
                rules={ rules.rfc }
                value={ data.rfc }
                onChange={ this.handleOnChange }
              />

              <FormControl type="username"
                name="username"
                label="Email o Teléfono"
                rules={ rules.username }
                value={ data.username }
                onChange={ this.handleOnChange }
              />

              <ReCAPTCHA
                size="invisible"
                ref={ this.recaptchaRef }
                sitekey={ process.env.REACT_APP_RECAPTCHA_KEY }
                onChange={ this.onCaptchaChange }
              />

              <Row>
                <Col className="text-right">
                  <LoadingButton type="button"
                    block={ true }
                    loading={ busy }
                    disabled={ !isValid || busy }
                    onClick={ this.handleOnSubmit }
                  >
                    { busy && 'Solicitando...'}
                    { !busy && 'Solicitar invitación' }
                  </LoadingButton>
                </Col>
              </Row>

              <div className="pt-3">
                { !!error && this.renderError() }
              </div>

              <Row>
                <Col className="text-center">
                  <Link to={{ pathname: '/ext/receptores/auth/login', search: !!query.tenancy ? `tenancy=${query.tenancy}` : '' }}>
                    Iniciar sesión
                  </Link>
                </Col>
              </Row>

            </div>
          </div>

        </div>
      </Form>
      )
    }
  }

  export default ReceptoresPasswordEmail;